"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 *
 * @param country País, 'MX' o 'AR'
 * @param section sección para obtener la landing
 * @returns path a la landing
 */
function getLandingPath(country, section) {
    if (typeof country === "undefined") {
        throw new Error("¡country is UNDEFINED!");
    }
    if (!section) {
        return `parametros/${country}/landings/`;
    }
    return `parametros/${country}/landings/${section}`;
}
exports.default = getLandingPath;
